import { render, staticRenderFns } from "./RilevazioneDettagliata.vue?vue&type=template&id=1af02c35&"
import script from "./RilevazioneDettagliata.vue?vue&type=script&lang=js&"
export * from "./RilevazioneDettagliata.vue?vue&type=script&lang=js&"
import style0 from "./RilevazioneDettagliata.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports